import TextInput from "components/form/input/TextInput"
import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields"
import AH from ".."

export function ParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={AH.field + tipoIndicadorField}
            bottomFields={
                <>
                    <ParamFormRow label="Intervalo de Aderência">
                        <TextInput name="mecanizado.intervaloMin" label="Mínimo" type="number" />
                        <TextInput name="mecanizado.intervaloMax" label="Máximo" type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="⁠Constante">
                        <TextInput name="mecanizado.constante" label="⁠Constante" type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Meta">
                        <TextInput name="mecanizado.meta" label="Meta (%)" type="number" />
                    </ParamFormRow>
                </>
            }
        />
    );
}
